import { useLocation } from 'react-router';

import { REDIRECT_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';

import { useBloomBasename } from './useBloomBasename';

function getRedirectRoute({
  basename,
  pathname,
  search,
  to,
}: {
  basename: string;
  pathname: string;
  search?: string;
  to: string;
}) {
  if (!pathname) return `${to}?${REDIRECT_QUERY_KEY}=${basename}`;
  if (pathname === `${basename}login`)
    return `${to}?${REDIRECT_QUERY_KEY}=${basename}`;

  return `${to}?${REDIRECT_QUERY_KEY}=${pathname}${encodeURIComponent(search ?? '')}`;
}

/**
 * Custom hook that returns a function to calculate the redirect route.
 * @returns {getRouteWithRedirect} A function that returns the redirect route
 */
export function useRouteWithRedirect() {
  const location = useLocation();
  const basename = useBloomBasename();

  const getRouteWithRedirect = (to: string, disabled?: boolean) => {
    return disabled
      ? to
      : getRedirectRoute({
          basename,
          pathname: location.pathname,
          search: location.search,
          to,
        });
  };

  return { getRouteWithRedirect };
}

/**
 * Calculates the redirect route. Compatible with actions and loaders.
 * @returns the redirect route
 */
export function routeWithRedirect({
  basename,
  redirectTo,
  to,
}: {
  basename: string;
  redirectTo: string;
  to: string;
}) {
  return `${basename}${to}?${REDIRECT_QUERY_KEY}=${basename}${encodeURIComponent(redirectTo)}`;
}
